<template>
  <FormTemplate
    class="form__wrapper"
    data-anim="fade"
    data-view="false"
  >
    <FormCore
      slot="core"
      data-theme="default"
      :slots="['row-1', 'row-2', 'row-3', 'row-4']"
    >
      <FormRow
        slot="row-1"
        :slots="['fname', 'lname']"
      >
        <FormInput
          slot="fname"
          :type="form.fname.type"
          :params="form.fname"
        />

        <FormInput
          slot="lname"
          :type="form.lname.type"
          :params="form.lname"
        />
      </FormRow>

      <FormRow
        slot="row-2"
        :slots="['email']"
      >
        <FormInput
          slot="email"
          :type="form.email.type"
          :params="form.email"
        />
      </FormRow>

      <FormRow
        slot="row-3"
        :slots="['message']"
      >
        <FormInput
          slot="message"
          :type="form.message.type"
          :params="form.message"
        />
      </FormRow>

      <FormRow
        slot="row-4"
        :slots="['privacy', 'submit']"
      >
        <FormInput
          slot="privacy"
          :type="form.privacy.type"
          :params="form.privacy"
        />

        <FormInput
          slot="submit"
          :type="form.submit.type"
          :params="form.submit"
        />
      </FormRow>
    </FormCore>
  </FormTemplate>
</template>

<script>
import translate from '@/assets/i18n';

import FormTemplate from './Form/index.vue';
import FormCore from './Form/FormCore/index.vue';
import FormRow from './Form/FormExtra/FormRow.vue';
import FormInput from './Form/FormInput/index.vue';

export default {
  name: 'Form',

  components: {
    FormTemplate,
    FormCore,
    FormRow,
    FormInput,
  },

  data() {
    return {
      form: {
        fname: {
          id: 'fname',
          name: 'fname',
          type: 'text',
          label: translate('NAME', this.$store.state.lang),
          autocomplete: 'given-name',
          size: 50,
          required: true,
        },
        lname: {
          id: 'lname',
          name: 'lname',
          type: 'text',
          label: translate('SURNAME', this.$store.state.lang),
          autocomplete: 'family-name',
          size: 50,
          required: true,
        },
        email: {
          id: 'email',
          name: 'email',
          type: 'email',
          label: translate('EMAIL', this.$store.state.lang),
          autocomplete: 'email',
          size: 100,
          required: true,
        },
        message: {
          id: 'message',
          name: 'message',
          type: 'textarea',
          label: translate('MESSAGE', this.$store.state.lang),
          cols: 30,
          rows: 4,
          size: 100,
          required: true,
        },
        privacy: {
          id: 'privacy',
          name: 'privacy',
          type: 'checkbox',
          choices: [{
            id: 'privacy',
            value: 'privacy',
            label: translate('PRIVACY', this.$store.state.lang),
          }],
          required: true,
        },
        submit: {
          id: 'submit',
          name: 'submit',
          type: 'submit',
          text: translate('SUBMIT', this.$store.state.lang),
          sending: translate('SENDING', this.$store.state.lang),
          sent: translate('SENT', this.$store.state.lang),
        },
      },
    };
  },
};
</script>

<style lang="scss">
.form__wrapper {
  margin-top: 160px;
}

input, textarea, select {
  font-family: $font-family-base;
}
</style>
